import Styled from 'styled-components'

export const Brand = Styled.h1`
`

export const Banner = Styled.div`

margin-bottom: 60px;
height: 290px;

img { 
    width: 100%;
    height: 100%;
    height: 290px;
    object-fit: cover;
}

.carousel-control-prev-icon{
    background-image: none !important;
}

.carousel-control-next-icon{
    background-image: none !important;
}

.carousel-indicators [data-bs-target] {
 background-color: rgba(5, 9, 34, 0.16) !important;
}

.carousel-indicators {
    align-items: center;
    margin-bottom: -52px !important;
}

.carousel-indicators .active {
    background-color: #050922 !important;
    width: 8px !important;
    height: 8px !important;
}

button{
    width: 6px !important;
    height: 6px !important; 
    background-color: #FFFFFF !important;
    border-radius: 100% !important;
}

`

export const CotainerProduct = Styled.div`
`

export const Cashback = Styled.div`
`
export const Space = Styled.div`
`
export const Label = Styled.p`
`
export const Title = Styled.p`
`